import { Component, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrl: './about.component.scss',
    imports: [TranslateModule, SharedModule],
    standalone: true,
})
export class AboutComponent implements OnDestroy {
    translate() {
        window.$wt?.etrans?.translate('#translate-content');
    }

    ngOnDestroy() {
        window.$wt?.etrans?.cancelTranslation();
    }
}
